import { signInWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FaLock, FaEnvelope, FaShieldAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { auth } from "./config";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const userCredential =
        await signInWithEmailAndPassword(
          auth,
          email,
          password
        );

      console.log("Logged In:", userCredential.user);

      navigate("/admin/dashboard");
    } catch (error) {
      console.error(error);

      switch (error.code) {
        case "auth/user-not-found":
          alert("User not found");
          break;

        case "auth/wrong-password":
          alert("Wrong password");
          break;

        case "auth/invalid-credential":
          alert("Invalid email or password");
          break;

        default:
          alert(error.message);
      }
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center bg-light">
      <Container fluid="lg">
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={5} xl={4}>
            <Card className="border-0 shadow-sm rounded-4 overflow-hidden">

              <Card.Body className="p-4 p-md-5">

                <div className="text-center mb-4">
                  <div
                    className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle bg-dark text-white"
                    style={{
                      width: "70px",
                      height: "70px",
                    }}
                  >
                    <FaShieldAlt size={28} />
                  </div>

                  <h3>Admin Login</h3>

                  <blockquote>
                    Secure access for authorized administrators only.
                  </blockquote>
                </div>

                <Form onSubmit={handleSubmit}>

                  <Form.Group className="mb-3">
                    <Form.Label>Email Address</Form.Label>

                    <div className="position-relative">
                      <FaEnvelope
                        className="position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary"
                      />

                      <Form.Control
                        type="email"
                        placeholder="Enter email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="ps-5"
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Password</Form.Label>

                    <div className="position-relative">
                      <FaLock
                        className="position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary"
                      />

                      <Form.Control
                        type="password"
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="ps-5"
                      />
                    </div>
                  </Form.Group>

                  <Button
                    variant="dark"
                    type="submit"
                    className="w-100 py-2 fw-semibold"
                  >
                    Login Securely
                  </Button>

                </Form>
              </Card.Body>

            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AdminLogin;